import { FingerIcon } from "common/Icons"
import { useFingerPrint } from "../hooks/useFingerPrint"
import Cookies from "js-cookie"
import { useRouterExternal } from "common/hooks/useRouterExternal"
import { setCookies } from "common/method/helper"
import { useSearchParams } from "react-router-dom"

export const FingerPrintLogin = () => {
    const [searchParams] = useSearchParams();
    const { loginAssertOption, loginWebAuth, loginMakeAssert } = useFingerPrint(searchParams)
    const { pushExternal } = useRouterExternal();

    const doneLogin = ({
        token,
        callBackUrl,
    }: Pick<responseAuthorizationType, 'token' | 'callBackUrl'>) => {
        setCookies(token);
        pushExternal(callBackUrl, token);
    };


    const loginWithFingerprints = () => {
        const fingerId = Cookies.get('fingerId')

        loginAssertOption(fingerId)
            .then(loginWebAuth)
            .then(loginMakeAssert)
            .then((res) => {
                if (res.succeeded) {
                    const { callBackUrl, token } = res.result || {}
                    doneLogin({ callBackUrl, token });
                }
                else {
                    console.log("succeeded:false", res)
                }
            })

    }

    return (
        <div className="text-center">
            <span
                onClick={loginWithFingerprints}
                className="p-2 rounded-full bg-white inline-block"
            >
                <FingerIcon />
            </span>
            <p className="mt-1 text-L-primary-50">ورود با اثر انگشت</p>
        </div>
    )
}
